<template>
  <div class="main-content">
    <b-row>
      <b-col cols="12">
        <h4>Approvals</h4>
      </b-col>
    </b-row>

    <hr/>

    <b-tabs content-class="mt-3">
      <b-tab title="E-Purse Transfer Approvals" active>
        <e-purse-transfers-tab />
      </b-tab>
      <b-tab title="Redemption Approvals">
        <redemption-approvals-tab />
      </b-tab>
      <b-tab title="Voucher Approvals">
        <voucher-approvals-tab />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import EPurseTransfersTab from './EPurseTransfers.vue';
import RedemptionApprovalsTab from './RedemptionApprovals.vue';
import VoucherApprovalsTab from './VoucherApprovals.vue';

export default {
  components: {
    EPurseTransfersTab,
    RedemptionApprovalsTab,
    VoucherApprovalsTab
  }
};
</script>

<style scoped>
</style>
